// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e0b1816c","703":"90314ea7","787":"813be768"}[chunkId] + ".chunk.js";
};